import scorecardMainHeader from './ScorecardMainHeader.js'
import scorecardAdHeader from './ScorecardAdHeader.js'
import scorecardNormHeader from './ScorecardNormHeader.js'
import scorecardMetricsLabels from './ScorecardMetricsLabels.js'
import scorecardNormValues from './ScorecardNormValues.js'
import scorecardMetricsValues from './ScorecardMetricsValues.js'

export default {
  dimensions: {
    rowHeight: 30,
    headerHeight: 245,
    headerHeightCollapsed: 150,
    metricsLabelsWidth: 350,
    normWidth: 100,
    metricWidth: 120
  },
  scorecardMainHeader,
  scorecardNormHeader,
  scorecardAdHeader,
  scorecardMetricsLabels,
  scorecardNormValues,
  scorecardMetricsValues
}



// WEBPACK FOOTER //
// ./src/app/configuration/FinancialServicesBanking/config/components/scorecard/ScorecardView/ScorecardScroller/index.js